(() => {
  const normalize = (value) => value.trim().toLocaleLowerCase('fr');

  const clearSizeChoice = (picker) => {
    const sizeFieldset = Array.from(picker.querySelectorAll('fieldset')).find((fieldset) => {
      const legend = fieldset.querySelector('legend');
      return legend && /pointure|taille|size/i.test(legend.textContent);
    });
    if (!sizeFieldset) return;

    sizeFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.checked = false;
    });

    const productInfo = picker.closest('product-info') || document;
    productInfo.querySelectorAll('product-form button[type="submit"]').forEach((button) => {
      button.disabled = true;
      const label = button.querySelector('span');
      if (label) label.textContent = 'Choisir une pointure';
    });
  };

  const selectLinkedColour = () => {
    const requestedColour = new URL(window.location.href).searchParams.get('vima_color');
    if (!requestedColour) return;
    const target = normalize(requestedColour);

    if (document.documentElement.dataset.vimaLinkedColourApplied === target) return;
    document.documentElement.dataset.vimaLinkedColourApplied = target;

    document.querySelectorAll('variant-selects').forEach((picker) => {
      picker.querySelectorAll('fieldset').forEach((fieldset) => {
        const legend = fieldset.querySelector('legend');
        if (!legend || !/couleur|color|colour/i.test(legend.textContent)) return;

        const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
          (candidate) => normalize(candidate.value) === target
        );
        if (!input) return;

        if (!input.checked) {
          const productInfo = picker.closest('product-info');
          let observer;
          if (productInfo) {
            observer = new MutationObserver(() => {
              const refreshedPicker = productInfo.querySelector('variant-selects');
              if (!refreshedPicker || refreshedPicker === picker) return;
              const selectedColour = Array.from(refreshedPicker.querySelectorAll('fieldset')).find((candidate) =>
                /couleur|color|colour/i.test(candidate.querySelector('legend')?.textContent || '')
              )?.querySelector('input:checked')?.value;
              if (selectedColour && normalize(selectedColour) === target) {
                clearSizeChoice(refreshedPicker);
                const cleanUrl = new URL(window.location.href);
                cleanUrl.search = '';
                cleanUrl.searchParams.set('vima_color', requestedColour);
                window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}`);
                observer.disconnect();
              }
            });
            observer.observe(productInfo, { childList: true, subtree: true });
            window.setTimeout(() => observer.disconnect(), 2500);
          }
          input.click();
        }
        clearSizeChoice(picker);
      });

      picker.querySelectorAll('select').forEach((select) => {
        const label = picker.querySelector(`label[for="${CSS.escape(select.id)}"]`);
        if (!label || !/couleur|color|colour/i.test(label.textContent)) return;

        const option = Array.from(select.options).find((candidate) => normalize(candidate.value) === target);
        if (option && select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      clearSizeChoice(picker);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectLinkedColour, { once: true });
  } else {
    selectLinkedColour();
  }
})();
